export default function Background() {
  return (
    <svg
      className="page__bg-shape"
      xmlns="http://www.w3.org/2000/svg"
      width="1289"
      height="929"
      viewBox="0 0 1289 929"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M1288.46 0V717.758L948.84 729.428L957.009 929L763.268 745.768L0 800.621V91.0329L1288.46 0Z"
        fill="#FFEFCC"
      />
    </svg>
  );
}
